import { getFingerprint } from '@thumbmarkjs/thumbmarkjs';
import { getEnvVar } from '@utils/get-env-var';
import { v4 as uuidv4 } from 'uuid';

const getFingerPrintPromise = async () => getFingerprint();

export const fingerPrintPromise = getFingerPrintPromise();
export const sessionIdString = uuidv4();

export const setSessionHeaders = async (headers: Headers) => {
    headers.set('X-Client-Id', await fingerPrintPromise);
    headers.set('X-Session-Id', sessionIdString);
};

export const setWidgetSessionHeaders = async (headers: Headers) => {
    await setSessionHeaders(headers);
    const widgetVersion = getEnvVar('REACT_APP_WIDGET_VERSION');

    if (widgetVersion) {
        headers.set('X-Widget-Version', widgetVersion);
    }
};
